<template>
  <div class="report-confirm-order">
    <Header pageTitle="确认订单" />
    <div class="content" ref="content">
      <div class="order-detail">
        <h1 class="box-title">{{ information.shopsName }}</h1>
        <div class="detail-flex">
          <img class="detail-cover" :src="information.pictureUrl" alt="" />
          <div class="detail-info">
            <h3 class="detail-title">{{ information.goodsTitle }}</h3>
            <p class="detail-notice">不支持退/换货</p>
            <p>
              <span class="detail-icon">¥</span>
              <span class="detail-price">{{ totalPrice }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="order-remark">
        <van-cell title="邮箱" is-link :value="email !== '' ? email : '必填'" :value-class="email !== '' ? 'cell-value' : ''"
          @click="openPopup('email')" />
        <van-cell title="订单备注" is-link :value="remark !== '' ? remark : '无备注'"
          :value-class="remark !== '' ? 'cell-value' : ''" @click="openPopup('remark')" />
        <van-cell v-if="Number(totalPrice) > 0" title="发票" is-link
          :value="userInvoiceInfo.invoiceHeader ? userInvoiceInfo.invoiceHeader : '不开发票'" value-class="cell-value"
          @click="toInvoice()" />
      </div>
      <!-- 支付方式 -->
      <div class="payment" v-if="Number(totalPrice) > 0">
        <h1 class="title">支付方式</h1>
        <van-radio-group v-model="radio" direction="horizontal">
          <div class="option">
            <div class="zhifubao">
              <img src="@/assets/mylogin/zhifubao-logo.png" alt="" />
              <div class="option_name">支付宝</div>
            </div>
            <van-radio name="1" style="margin-top: 18px"></van-radio>
          </div>
          <div class="option">
            <div class="weixin">
              <img src="@/assets/mylogin/weixinzhifu2@2x.png" alt="" />
              <div class="option_name">微信支付</div>
            </div>
            <van-radio name="2" style="margin-top: 18px"></van-radio>
          </div>
        </van-radio-group>
      </div>
      <van-action-sheet v-model="emailPopupShow" title="邮箱">
        <div class="popup-content">
          <van-field @focus="handleElemInView" class="popup-input" v-model="emailPopup" placeholder="请输入邮箱" />
          <van-button class="popup-btn" type="default" @click="confirmEmail()">确定</van-button>
        </div>
      </van-action-sheet>
      <van-action-sheet v-model="remarkPopupShow" title="备注">
        <div class="popup-content">
          <van-field @focus="handleElemInView" class="popup-input popup-textarea" v-model="remarkPopup" rows="8"
            type="textarea" maxlength="200" placeholder="请输入备注" show-word-limit />
          <van-button class="popup-btn" type="default" @click="confirmRemark()">确定</van-button>
        </div>
      </van-action-sheet>
    </div>

    <!-- 底部按钮 -->
    <div class="submit">
      <div class="money">¥{{ totalPrice }}</div>
      <van-button type="info" class="obt" @click="generate" :disabled="btnDisabled">提交订单</van-button>
    </div>
  </div>
</template>
  
<script>
import { Toast } from "vant";
import Header from "@/views/mobileView/components/header";
export default {
  name: "ReportOrdeyPay",
  components: {
    Header,
  },
  computed: {
    totalPrice() {
      return (
        (
          (this.information.skuPrice * 100 * this.information.selectedNum) /
          100
        ).toFixed(2) + ""
      );
    },
  },
  data() {
    return {
      radio: "1",
      information: {},
      confirmList: [],
      email: "",
      emailPopupShow: false,
      emailPopup: "",
      remark: "",
      remarkPopupShow: false,
      remarkPopup: "",
      btnDisabled: false,
      userInvoiceInfo: {}
    };
  },
  created() {
    this.userInvoiceInfo = sessionStorage.getItem("userInvoiceInfo") ? JSON.parse(sessionStorage.getItem("userInvoiceInfo")) : {};
    this.information = JSON.parse(localStorage.getItem("reprotDetails"));
    this.confirmList = JSON.parse(localStorage.getItem("reprotParameter"));
  },
  methods: {
    toInvoice() {
      let query = {
        from: 'orderConfirm',
      }
      this.$router.push({ path: '/invoice', query })
    },
    // 打开填写信息弹窗
    openPopup(name) {
      this[`${name}Popup`] = this[name];
      this[`${name}PopupShow`] = true;
    },
    // 备注弹窗确认
    confirmRemark() {
      this.remark = this.remarkPopup;
      this.remarkPopupShow = false;
    },
    // 邮箱弹窗确认
    confirmEmail() {
      const pattern = new RegExp(
        "^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$"
      );
      if (pattern.test(this.emailPopup) && this.emailPopup.length <= 200) {
        this.email = this.emailPopup;
        this.emailPopupShow = false;
      } else {
        Toast("邮箱填写错误，请检查后重新填写。");
      }
    },
    // 生成订单
    async generate() {
      if (this.email !== "") {
        this.btnDisabled = true;
        let obj = {
          list: this.confirmList,
          originProject: "information",
          email: this.email,
        };
        if (sessionStorage.getItem("userInvoiceInfo")) {
          let userInvoiceInfo = JSON.parse(sessionStorage.getItem("userInvoiceInfo"))
          let userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
          userInvoiceInfo.invoicePrice = this.totalPrice
          userInvoiceInfo.userId = userInfo.user.id
          obj.userInvoiceInfo = userInvoiceInfo
        }
        if (this.remark !== "") obj.remark = this.remark;
        const resp = await this.$apis.paymentServe.generate(obj);
        if (resp.resultCode === "200") {
          if (resp.data.payStatus == 0) {
            // 免费商品，不需要调支付接口，直接生成订单跳转订单列表或者详情
            this.$router.push({ path: "/orders" });
          } else {
            this.$router.replace({
              path: "/orderDetails",
              query: {
                id: resp.data.payBatchid,
                createTime: resp.data.createTime,
                isPrimaryOrder: true,
                payType: this.radio,
              },
            });
          }
        } else {
          // 判断当前商品状态
          Dialog.confirm({
            message: "商品信息发生改变，请重新选择购买",
          }).then(() => {
            window.history.go(-1);
          });
          this.btnDisabled = false;
        }
      } else {
        Toast("请填写邮箱");
      }
    },
    // 确保输入框不被软键盘遮挡 处理ios16问题
    handleElemInView(e) {
      console.log(
        "document.body.scrollHeight",
        document.body.scrollHeight,
        "window.innerHeight",
        window.innerHeight,
        "document.body.scrollTop",
        document.body.scrollTop,
        "e.target",
        e.target,
        this.$refs.content.offsetHeight
      );
      // e.target.scrollIntoViewIfNeeded(false);
      // e.target.scrollIntoView(false)
      window.scrollTo(0, window.innerHeight - 375);
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'ReportDetails' || to.name === 'tobepaid' || to.name === 'orders') {
      sessionStorage.removeItem("userInvoiceInfo");
    }
    next()
  },
};
</script>
  
<style lang="scss" scoped>
.report-confirm-order {
  padding-top: 44px;
  min-height: 100vh;
  background-color: #f5f5f5;

  .content {
    margin: 0 auto;
    width: 351px;

    .order-detail {
      margin-top: 12px;
      padding: 15px 12px;
      width: 100%;
      background-color: #fff;
      border-radius: 8px;

      .box-title {
        margin-bottom: 15px;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
      }

      .detail-flex {
        display: flex;

        .detail-cover {
          width: 80px;
          height: 80px;
          border-radius: 6px;
        }

        .detail-info {
          width: 231px;
          margin-left: 10px;

          .detail-title {
            font-size: 15px;
            color: #333333;
            line-height: 23px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .detail-notice {
            margin: 8px 0;
            font-size: 12px;
            color: #ff3d3d;
            line-height: 21px;
          }

          .detail-icon {
            font-size: 12px;
            color: #333;
          }

          .detail-price {
            font-size: 16px;
            color: #333;
          }
        }
      }
    }

    .order-remark {
      margin-top: 12px;
      padding: 5px 0;
      width: 100%;
      background-color: #fff;
      border-radius: 8px;
      overflow: hidden;

      .cell-value {
        font-size: 14px;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .payment {
      margin-top: 12px;
      padding: 12px;
      background-color: #fff;
      border-radius: 8px;

      .title {
        font-size: 14px;
        color: #333333;
        line-height: 20px;
      }

      .option {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 80px;

        ::v-deep.van-radio__icon--checked .van-icon {
          background-color: #4a79f1;
          border-color: #4a79f1;
        }

        .zhifubao {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          img {
            width: 30px;
            height: 30px;
          }

          .option_name {
            font-size: 15px;
            color: #333333;
            line-height: 21px;
            margin-left: 15px;
            width: 250px;
          }

          .img-icon {
            width: 20px;
            height: 20px;
          }
        }

        .weixin {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          img {
            width: 30px;
            height: 30px;
          }

          .option_name {
            font-size: 15px;
            color: #333333;
            line-height: 21px;
            margin-left: 15px;
            width: 250px;
          }

          .img-icon {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }
}

.popup-content {
  margin: 25px 25px 5px;

  .popup-input {
    margin-bottom: 55px;
    background-color: #f5f5f5;
    border-radius: 8px;
  }

  .popup-textarea {
    margin-bottom: 19px;
  }

  .popup-btn {
    width: 100%;
    height: 44px;
    background-color: #4a79f1;
    border-radius: 22px;
    font-size: 16px;
    color: #ffffff;
    line-height: 44px;
  }
}

.submit {
  width: 100%;
  position: fixed;
  bottom: 0px;
  height: 49px;
  background: #fff;
  display: flex;
  padding: 0px 0px 0px 15px;

  .money {
    font-size: 21px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff3d3d;
    line-height: 17px;
    width: 190px;
    margin-top: 16px;
  }

  .obt {
    width: 160px;
    height: 44px;
    border-radius: 22px;
    margin-top: 3px;
    margin-right: 15px;
  }
}
</style>